<template>
  <!-- 路由[主显示] -->
  <router-view style="margin-top: 60px" :key="$route.fullPath"/>
</template>

<script>

import AxiosBase from "@/components/axiosBase";
import DataStorePersisted from "@/components/dataStorePersisted";
import store from "@/components/dataStore";

export default {
  name: 'App',
  store,
  beforeMount() {
    AxiosBase.axiosGet("/user/login-status", {}).then(response => {
      if (response !== 0) {
        if (response.remark === '1') {
          DataStorePersisted.state.isLogin = true;
        } else {
          this.$store.state.userInfo = {};
        }
      }
    })
  }
}
</script>